var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox-container",style:(_vm.customStyle),on:{"click":function($event){return _vm.onSelect(_vm.title)}}},[_c('div',{staticClass:"checkbox",class:{
      'checkbox selected': _vm.checked
    }},[(_vm.checked)?_c('img',{staticClass:"checkbox-img",attrs:{"src":require("@/assets/images/check_1.png")}}):_vm._e()]),_c('div',{staticClass:"checkbox-title",class:{
      'checkbox-title selected': _vm.checked
    }},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }